import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import CourseStatsStateSlice from "../../../models/state/courseStats";
import * as metaSelectors from "./meta";
import * as statsSelectors from "./stats";
import { CourseStatsMetaSelectors, CourseStatsSelectors } from "./types";

type State = CourseStatsStateSlice;

function getCoursesMetasStats(state: State) {
  //TODO: update model to be a record and get rid of 'get'
  return state.get("stats");
}

function getCourseStatsMeta(state: State) {
  return state.get("meta");
}

// @ts-ignore
export const {
  getTotalStudyTime,
  getScore,
  getSessionsCompleted,
  getNumberOfModulesStudied,
  getProficiency,
  getLastStudied
}: CourseStatsSelectors<State> = composeSelectors(
  // @ts-ignore
  getCoursesMetasStats,
  statsSelectors
);

// @ts-ignore
export const {
  courseStatFetchSucceeded,
  courseStatFetchErrored,
  courseStatFetchFinished,
  courseStatNeedsFetching,
  allCourseStatsFetchErrored,
  allCourseStatsFetchFinished,
  allCourseStatsNeedsFetching
}: CourseStatsMetaSelectors<State> = composeSelectors(
  // @ts-ignore
  getCourseStatsMeta,
  metaSelectors
);
